export default {
    //pathImg: 'http://localhost:8000/public/uploads',
  pathImg: 'https://api.inseg.com.ec/public/uploads',

   // api: 'http://localhost:8000/api',
    api: 'https://api.inseg.com.ec/api',

}
